'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TimeAgo = require('../TimeAgo');

var _TimeAgo2 = _interopRequireDefault(_TimeAgo);

var _ShareButton = require('../ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _ContentCardFooter = require('./ContentCardFooter.css');

var _ContentCardFooter2 = _interopRequireDefault(_ContentCardFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentCardFooter = function (_React$Component) {
  _inherits(ContentCardFooter, _React$Component);

  function ContentCardFooter(props) {
    _classCallCheck(this, ContentCardFooter);

    var _this = _possibleConstructorReturn(this, (ContentCardFooter.__proto__ || Object.getPrototypeOf(ContentCardFooter)).call(this, props));

    _this.onProxyClick = _this.onProxyClick.bind(_this);
    return _this;
  }

  _createClass(ContentCardFooter, [{
    key: 'onProxyClick',
    value: function onProxyClick(event) {
      var newWindow = window.open() || window;
      newWindow.opener = null; /* Prevent vulnerability */
      newWindow.location = this.url;
      event.stopPropagation();
    }
  }, {
    key: 'renderInfo',
    value: function renderInfo(url) {
      var info = _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _ContentCardFooter2.default.__scopedHash + ' ' + 'info'
        },
        _react2.default.createElement(_TimeAgo2.default, { date: this.props.publishedAt }),
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _ContentCardFooter2.default.__scopedHash + ' ' + 'bullet'
          },
          '\u2022'
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _ContentCardFooter2.default.__scopedHash + ' ' + 'source'
          },
          this.source
        ),
        _react2.default.createElement(_style2.default, {
          styleId: _ContentCardFooter2.default.__scopedHash,
          css: _ContentCardFooter2.default.__scoped
        })
      );
      if (url) {
        return _react2.default.createElement(
          'div',
          { onClick: this.onProxyClick, tabIndex: '0', role: 'button', title: this.source, className: 'jsx-' + _ContentCardFooter2.default.__scopedHash + ' ' + 'link'
          },
          info,
          _react2.default.createElement(_style2.default, {
            styleId: _ContentCardFooter2.default.__scopedHash,
            css: _ContentCardFooter2.default.__scoped
          })
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        info
      );
    }
  }, {
    key: 'render',
    value: function render() {
      this.source = this.props.source;
      this.url = this.props.url;
      if (typeof this.source === 'string') {
        this.source = this.source.replace(/^@/, '');
      }
      return _react2.default.createElement(
        'div',
        {
          style: this.props.styleOverrides ? this.props.styleOverrides.contentCardFooterStyles : null,
          className: 'jsx-' + _ContentCardFooter2.default.__scopedHash + ' ' + ('footer ' + (this.props.isLarge ? 'isLarge' : ''))
        },
        this.renderInfo(this.url),
        this.props.shareUrl && _react2.default.createElement(_ShareButton2.default, {
          isLarge: this.props.isLarge,
          shareText: this.props.shareText,
          shareUrl: this.props.shareUrl,
          trackEvent: this.props.trackEvent,
          styleOverrides: this.props.styleOverrides ? this.props.styleOverrides.shareButtonStyles : null
        }),
        _react2.default.createElement(_style2.default, {
          styleId: _ContentCardFooter2.default.__scopedHash,
          css: _ContentCardFooter2.default.__scoped
        })
      );
    }
  }]);

  return ContentCardFooter;
}(_react2.default.Component);

ContentCardFooter.propTypes = {
  publishedAt: _propTypes2.default.string.isRequired,
  shareText: _propTypes2.default.string,
  shareUrl: _propTypes2.default.string,
  source: _propTypes2.default.node.isRequired,
  trackEvent: _propTypes2.default.func,
  url: _propTypes2.default.string,
  isLarge: _propTypes2.default.bool,
  styleOverrides: _propTypes2.default.shape({
    contentCardFooterStyles: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    shareButtonStyles: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
  })
};

ContentCardFooter.defaultProps = {
  shareText: null,
  shareUrl: null,
  trackEvent: null,
  url: null,
  isLarge: false,
  styleOverrides: null
};

exports.default = ContentCardFooter;